import classNames from 'classnames';
import React from 'react';

import {ElementMouseEvent} from 'util/Types';

interface ContinueButtonProps {
  text: string;
  onClick?: (e: ElementMouseEvent) => void;
  primary?: boolean;
  disabled?: boolean;
}

export default function ContinueButton({
  text,
  onClick,
  primary,
  disabled = false,
}: ContinueButtonProps): JSX.Element {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={classNames('button button--large button--success', {
        'button--tertiaryBlue': !primary,
        'button--primary': primary,
        'is-disabled': disabled,
      })}
      type="button"
    >
      {text}
    </button>
  );
}
